/* BA-16 Camgard: pencere filminin 2/4 adet paketine aparat seti hediyesi (0 TL ayrı ürün).
   Sepette uygun paket varsa hediye 1 adet olur, yoksa silinir. Sayfa açılınca ve her sepet değişiminde çalışır.
   Ayarlar cg-gift-config snippet'inden gelir: window.cgGift = { g: hediye varyant id, p: pencere ürün id, min: 2,
   d: duşakabin ürün id, dmin: 4 } (BA-34: duşakabin 4/8 metre de hediye alır; hediye her durumda tek). */
(function () {
  const cfg = window.cgGift;
  if (!cfg || !cfg.g || !cfg.p || window.cgGiftReady) return;
  window.cgGiftReady = true;
  const MIN = cfg.min || 2;

  // "Küçük 60 cm x 2 metre - 2 Adet" → 2. Yalnız paket varyantı sayılır; 1 Adet × 2 sayılmaz.
  const packOf = (item) => {
    const m = /(\d+)\s*Adet/i.exec(item.variant_title || '');
    return m ? Number(m[1]) : 1;
  };
  // BA-34: duşakabin "60 cm x 4 metre" → 4. Uzunluk dmin (4) metre ve üstüyse hediye; 2 metre almaz.
  const metersOf = (item) => {
    const m = /(\d+)\s*metre/i.exec(item.variant_title || '');
    return m ? Number(m[1]) : 0;
  };
  const eligible = (cart) => cart.items.some((i) => (i.product_id === cfg.p && packOf(i) >= MIN)
    || (cfg.d && i.product_id === cfg.d && metersOf(i) >= (cfg.dmin || 4)));

  const json = (url, body) => fetch(url, body
    ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
    : { headers: { Accept: 'application/json' } }).then((r) => r.json());

  // Bölümler değişiklik isteğinin kendi cevabıyla gelir; ayrı GET hemen ardından eski sepeti çizebiliyor.
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const onCartPage = () => !!document.getElementById('main-cart-items');
  const withSections = (body) => (onCartPage() ? body : Object.assign(body, { sections: SECTIONS, sections_url: window.location.pathname }));

  // Hediye satırlarını hedef duruma getirir. Değişiklik yaptıysa cevabı ({ sections, item_count }) döner, yoksa null.
  async function fix(cart) {
    const lines = cart.items.filter((i) => i.variant_id === cfg.g);
    const want = eligible(cart) ? 1 : 0;
    const updates = {};
    let left = want;
    for (const l of lines) {
      const q = left > 0 ? 1 : 0;
      left -= q;
      if (l.quantity !== q) updates[l.key] = q;
    }
    if (left > 0) {
      const r = await json(window.routes.cart_add_url + '.js', withSections({ items: [{ id: cfg.g, quantity: 1 }] }));
      return { sections: r.sections, item_count: cart.item_count + 1 };
    }
    if (Object.keys(updates).length) {
      const r = await json(window.routes.cart_update_url + '.js', withSections({ updates }));
      return { sections: r.sections, item_count: r.item_count };
    }
    return null;
  }

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  // Çekmeceyi açmadan yeniler (Dawn renderContents çekmeceyi açar, bu yüzden kullanılmaz).
  function repaint(res) {
    // Sepet sayfasında Dawn ara toplamı ayrı bölümde tutar; tam yenileme en güvenlisi (ikinci turda değişiklik olmaz).
    if (onCartPage()) { window.location.reload(); return; }
    const s = res.sections || {};
    const drawer = document.querySelector('cart-drawer');
    const inner = s['cart-drawer'] && parse(s['cart-drawer']).querySelector('#CartDrawer');
    const cur = document.getElementById('CartDrawer');
    if (drawer && inner && cur) {
      cur.innerHTML = inner.innerHTML;
      drawer.classList.toggle('is-empty', res.item_count === 0);
      const ov = drawer.querySelector('#CartDrawer-Overlay');
      if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
      // İçerik değişince odak düşer; çekmece açıksa odağı geri ver ki Esc ve Tab çalışsın.
      if (drawer.classList.contains('active') && typeof trapFocus === 'function') {
        const box = drawer.querySelector('.drawer__inner');
        const first = drawer.querySelector('.cart-item__name') || drawer.querySelector('.drawer__close');
        if (box && first) trapFocus(box, first);
      }
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const b = s['cart-icon-bubble'] && parse(s['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && b) bubble.innerHTML = b.innerHTML;
  }

  let running = false; let again = false;
  async function sync() {
    if (running) { again = true; return; }
    running = true;
    try {
      let last = null;
      for (let i = 0; i < 3; i++) {
        const r = await fix(await json(window.routes.cart_url + '.js'));
        if (!r) break;
        last = r;
      }
      if (last) repaint(last);
    } catch (e) {
      console.warn('cg-gift', e);
    } finally {
      running = false;
      if (again) { again = false; sync(); }
    }
  }
  window.cgGiftSync = sync;

  const start = () => {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => { setTimeout(sync, 50); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Geri tuşuyla önbellekten dönülen sayfada sepet değişmiş olabilir.
  window.addEventListener('pageshow', (e) => { if (e.persisted) sync(); });
})();
